<mat-accordion *ngIf="!isImpersonating">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Lista de Usuarios </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar usuario</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Escribe un nombre o usuario">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="mat-elevation-z4 table-container">
      <app-data-table
        tableClass="full-width-table"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [emptyMessage]="'No hay usuarios disponibles.'">
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef> Usuario </th>
          <td mat-cell *matCellDef="let user"> {{user.username}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let user">
            <button mat-button color="primary" (click)="loginAs(user.username)" [disabled]="isImpersonating">
              Entrar como
            </button>
          </td>
        </ng-container>
      </app-data-table>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<mat-toolbar color="warn" *ngIf="isImpersonating">
  <span>Actuas como: <b>{{ impersonatedUser }}</b></span>
  <span class="spacer"></span>
  <button mat-button (click)="stop()">Volver a Admin</button>
</mat-toolbar>
